import createEntityChangementConfig2 from '@infrastructure/entityChangement/createEntityChangementConfig2'
import { getEntityChangementMessage } from '@infrastructure/entityChangement/utils'
import queryClient from '@infrastructure/reactQuery/queryClient'
import toast from '@infrastructure/toast/toast'

import markerUnitRQKeys from '../reactQuery/markerUnitRQKeys'
import { markerUnitEntityName } from '../service/constants'

export default createEntityChangementConfig2({
  entity: markerUnitEntityName,
  config: [
    {
      changements: ['created', 'updated', 'deleted'],
      listener: ({ name, type }) => {
        toast.info({
          title: getEntityChangementMessage(name, type)
        })
        const key = markerUnitRQKeys.lists()
        queryClient.invalidateQueries(key)
      }
    },
    {
      changements: ['updated'],
      listener: ({ meta: { id } }) => {
        const key = markerUnitRQKeys.detail(id)
        queryClient.invalidateQueries(key)
      }
    },
    {
      changements: ['deleted'],
      listener: ({ meta: { id } }) => {
        const key = markerUnitRQKeys.detail(id)
        queryClient.removeQueries(key)
      }
    }
  ]
})
